<template>
  <div id="merchantInfo">
    <div class="header-nav flex-align">
      <div class="nav-right flex-align">
        <global-outlined class="ic-lanage" />
        <language-selector style="padding-left: 10px;" />
      </div>
    </div>
    <div class="merchant-body">
      <div class="body-left">
        <img class="body_left_logo" src="~@/assets/images/login-logo-most.png">
        <a-menu
          v-model:selectedKeys="selectedKeys"
          v-model:openKeys="openKeys"
          mode="inline"
          style="height: 100%;overflow-y: scroll;scrollbar-width: none;padding-top: 30px;border-right: 0px;margin-left: 50px;"
          @click="({ key }) => handleNext(key)"
        >
          <a-sub-menu key="1">
            <template #title>{{ $t('pages_merchant_001') }}</template>
            <template #icon><div class="menu_icon">1</div></template>
            <a-menu-item key="1-1">
              <template #icon>
                <close-outlined v-if="companyNameInfo.icon === 3" class="ic-error" />
                <check-circle-outlined v-if="companyNameInfo.icon === 2" class="ic-correct" />
                <div v-if="companyNameInfo.icon !== 2 && companyNameInfo.icon !== 3" class="icon-border" :style="{background:selectedKeys.includes('1-1')?'#BA8438':'#00000066'}" />
              </template>
              {{ $t('pages_merchant_004') }}
            </a-menu-item>
            <!-- <a-menu-item key="1-2">
              <template #icon>
                <close-outlined v-if="parentCompanyInfo.icon === 3" class="ic-error" />
                <check-circle-outlined v-if="parentCompanyInfo.icon === 2" class="ic-correct" />
                <div v-if="parentCompanyInfo.icon !== 3 && parentCompanyInfo.icon !== 3" class="icon-border" :style="{background:selectedKeys.includes('1-2')?'#BA8438':'#00000066'}" />
              </template>
              {{ $t('pages_merchant_005') }}
            </a-menu-item> -->
            <!-- <a-menu-item key="1-3">
              <template #icon>
                <close-outlined v-if="branchOfficeSubsidiary.icon === 3" class="ic-error" />
                <check-circle-outlined v-if="branchOfficeSubsidiary.icon === 2" class="ic-correct" />
                <div v-if="branchOfficeSubsidiary.icon !== 2 && branchOfficeSubsidiary.icon !== 3" class="icon-border" :style="{background:selectedKeys.includes('1-3')?'#BA8438':'#00000066'}" />
              </template>
              {{ $t('pages_merchant_006') }}
            </a-menu-item> -->
            <a-menu-item key="1-4">
              <template #icon>
                <close-outlined v-if="companyBasicInfo.icon === 3" class="ic-error" />
                <check-circle-outlined v-if="companyBasicInfo.icon === 2" class="ic-correct" />
                <div v-if="companyBasicInfo.icon !== 2 && companyBasicInfo.icon !== 3" class="icon-border" :style="{background:selectedKeys.includes('1-4')?'#BA8438':'#00000066'}" />
              </template>
              {{ $t('pages_merchant_153') }}
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="2">
            <template #title>{{ $t('pages_merchant_002') }}</template>
            <template #icon><div class="menu_icon">2</div></template>
            <a-menu-item key="2-1">
              <template #icon>
                <close-outlined v-if="businessLicenseInfo.icon === 3" class="ic-error" />
                <check-circle-outlined v-if="businessLicenseInfo.icon === 2" class="ic-correct" />
                <div v-if="businessLicenseInfo.icon !== 2 && businessLicenseInfo.icon !== 3" class="icon-border" :style="{background:selectedKeys.includes('2-1')?'#BA8438':'#00000066'}" />
              </template>
              <!-- <span v-if="companyNameInfo.countryCode === 'CN'">{{ $t('pages_merchant_007') }}</span>
              <span v-else-if="companyNameInfo.countryCode === 'HK'">{{ $t('pages_merchant_016') }}</span>
              <span v-else>{{ $t('pages_merchant_017') }}</span> -->
              {{ $t('pages_merchant_017') }}
            </a-menu-item>
            <!-- <a-menu-item v-if="!['CN'].includes(companyNameInfo.countryCode)" key="2-2">
              <template #icon>
                <close-outlined v-if="articlesAssociation.icon === 3" class="ic-error" />
                <check-circle-outlined v-if="articlesAssociation.icon === 2" class="ic-correct" />
                <div v-if="articlesAssociation.icon !== 2 && articlesAssociation.icon !== 3" class="icon-border" :style="{background:selectedKeys.includes('2-2')?'#BA8438':'#00000066'}" />
              </template>
              {{ $t('pages_merchant_018') }}
            </a-menu-item> -->
            <!-- <a-menu-item v-if="!['CN'].includes(companyNameInfo.countryCode)" key="2-3">
              <template #icon>
                <close-outlined v-if="annualReportInc.icon === 3" class="ic-error" />
                <check-circle-outlined v-if="annualReportInc.icon === 2" class="ic-correct" />
                <div v-if="annualReportInc.icon !== 2 && annualReportInc.icon !== 3" class="icon-border" :style="{background:selectedKeys.includes('2-3')?'#BA8438':'#00000066'}" />
              </template>
              {{ $t('pages_merchant_019') }}
            </a-menu-item> -->
            <!-- <a-menu-item key="2-4">
              <template #icon>
                <close-outlined v-if="identityInfo.icon === 3" class="ic-error" />
                <check-circle-outlined v-if="identityInfo.icon === 2" class="ic-correct" />
                <div v-if="identityInfo.icon !== 2 && identityInfo.icon !== 3" class="icon-border" :style="{background:selectedKeys.includes('2-4')?'#BA8438':'#00000066'}" />
              </template>
              {{ $t('pages_merchant_008') }}
            </a-menu-item> -->
            <!-- <a-menu-item key="2-5">
              <template #icon>
                <close-outlined v-if="certufucate.icon === 3" class="ic-error" />
                <check-circle-outlined v-if="certufucate.icon === 2" class="ic-correct" />
                <div v-if="certufucate.icon !== 2 && certufucate.icon !== 3" class="icon-border" :style="{background:selectedKeys.includes('2-5')?'#BA8438':'#00000066'}" />
              </template>
              {{ $t('pages_merchant_009') }}
            </a-menu-item> -->
            <!-- <a-menu-item key="2-6">
              <template #icon>
                <close-outlined v-if="resolutionPower.icon === 3" class="ic-error" />
                <check-circle-outlined v-if="resolutionPower.icon === 2" class="ic-correct" />
                <div v-if="resolutionPower.icon !== 2 && resolutionPower.icon !== 3" class="icon-border" :style="{background:selectedKeys.includes('2-6')?'#BA8438':'#00000066'}" />
              </template>
              {{ $t('pages_merchant_010') }}
            </a-menu-item> -->
          </a-sub-menu>
          <!-- <a-sub-menu key="3">
            <template #title>{{ $t('pages_merchant_003') }}</template>
            <template #icon><div class="menu_icon">3</div></template>
            <a-menu-item key="3-1">
              <template #icon>
                <close-outlined v-if="transactionInfo.icon === 3" class="ic-error" />
                <check-circle-outlined v-if="transactionInfo.icon === 2" class="ic-correct" />
                <div v-if="transactionInfo.icon !== 2 && transactionInfo.icon !== 3" class="icon-border" :style="{background:selectedKeys.includes('3-1')?'#BA8438':'#00000066'}" />
              </template>
              {{ $t('pages_merchant_161') }}
            </a-menu-item>
            <a-menu-item key="3-2">
              <template #icon>
                <close-outlined v-if="otherInfo.icon === 3" class="ic-error" />
                <check-circle-outlined v-if="otherInfo.icon === 2" class="ic-correct" />
                <div v-if="otherInfo.icon !== 2 && otherInfo.icon !== 3" class="icon-border" :style="{background:selectedKeys.includes('3-2')?'#BA8438':'#00000066'}" />
              </template>
              {{ $t('pages_merchant_128') }}
            </a-menu-item>
            <a-menu-item v-if="risked" key="3-3">
              <close-outlined v-if="eddRefuseInfo.icon === 3" class="ic-error" />
              <check-circle-outlined v-if="eddRefuseInfo.icon === 2" class="ic-correct" />
              <div v-if="eddRefuseInfo.icon !== 2 && eddRefuseInfo.icon !== 3" class="icon-border" :style="{background:selectedKeys.includes('3-3')?'#BA8438':'#00000066'}" />
              EDD
            </a-menu-item>
            <a-menu-item key="3-4">
              <template #icon>
                <close-outlined v-if="declareInfo.icon === 3" class="ic-error" />
                <check-circle-outlined v-if="declareInfo.icon === 2" class="ic-correct" />
                <div v-if="declareInfo.icon !== 2 && declareInfo.icon !== 3" class="icon-border" :style="{background:selectedKeys.includes('3-4')?'#BA8438':'#00000066'}" />
              </template>
              {{ $t('pages_merchant_013') }}
            </a-menu-item>
          </a-sub-menu> -->
        </a-menu>
      </div>
      <div class="body-right">
        <div style="width: 720px;padding: 38px;box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.12);">
          <company-register
            v-if="selectedKeys.includes('1-1')"
            v-model:pattern="pattern"
            :model="companyNameInfo"
            :refused="refused"
            :countries="countries"
            @next="handleNext"
            @update="countryChange"
          />
          <company-parents
            v-if="selectedKeys.includes('1-2')"
            :model="parentCompanyInfo"
            :refused="refused"
            :countries="countries"
            @next="handleNext"
          />
          <company-sons
            v-if="selectedKeys.includes('1-3')"
            :model="branchOfficeSubsidiary"
            :refused="refused"
            :countries="countries"
            @next="handleNext"
          />
          <!-- 公司基础信息 -->
          <company-basic
            v-if="selectedKeys.includes('1-4')"
            :model="companyBasicInfo"
            :refused="refused"
            :countries="countries"
            @next="handleNext"
          />
          <business-license
            v-if="selectedKeys.includes('2-1')"
            ref="submitRef"
            :model="businessLicenseInfo"
            :refused="refused"
            :country-code="companyNameInfo.countryCode"
            @next="handleNext"
            @finish="handleFinish"
          />
          <articles-association
            v-if="selectedKeys.includes('2-2')"
            :model="articlesAssociation"
            :country-code="companyNameInfo.countryCode"
            :refused="refused"
            @next="handleNext"
          />
          <annual-report-inc
            v-if="selectedKeys.includes('2-3')"
            :model="annualReportInc"
            :refused="refused"
            @next="handleNext"
          />
          <author-identity
            v-if="selectedKeys.includes('2-4')"
            :model="identityInfo"
            :refused="refused"
            :country-code="companyNameInfo.countryCode"
            @next="handleNext"
            @edit="identityChange"
          />
          <person-certificate
            v-if="selectedKeys.includes('2-5')"
            :model="certufucate"
            :refused="refused"
            :country-code="companyNameInfo.countryCode"
            :customer-identity="identityInfo.customerIdentity"
            :countries="countries"
            :refuse-attrs="refuseAttrs"
            @next="handleNext"
          />
          <resolution-power
            v-if="selectedKeys.includes('2-6')"
            :model="resolutionPower"
            :refused="refused"
            :theme-data="themeData"
            :country-code="companyNameInfo.countryCode"
            @next="handleNext"
          />
          <!-- <source-funds
            :model="sourceFundsInfo"
            :refused="refused"
            @next="handleNext"
          /> -->
          <transaction-related
            v-if="selectedKeys.includes('3-1')"
            :model="transactionInfo"
            :refused="refused"
            @next="handleNext"
          />
          <!-- <source-whereabouts
            v-if="selectedKeys.includes('3-2')"
            :model="sourceWhereabouts"
            :refused="refused"
            :risked="risked"
            @next="handleNext"
          /> -->
          <other-funds
            v-if="selectedKeys.includes('3-2')"
            :model="otherInfo"
            :liveness="liveness"
            :refused="refused"
            :risked="risked"
            :country-code="companyNameInfo.countryCode"
            :kycid="kycId"
            @next="handleNext"
          />
          <risk-supply
            v-if="selectedKeys.includes('3-3')"
            :model="eddRefuseInfo"
            :refused="refused"
            :countries="countries"
            @next="handleNext"
          />
          <declare-page
            v-if="selectedKeys.includes('3-4')"
            ref="submitRef"
            :model="declareInfo"
            :refused="refused"
            :risked="risked"
            :theme-data="themeData"
            @next="handleNext"
            @finish="handleFinish"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, reactive, toRefs, watch, inject } from 'vue'
import { useRouter } from 'vue-router'
import { _user, _receive, _home } from '@/api'
import { message } from 'ant-design-vue'
import i18n from '@/locale'
import CompanyRegister from './components/company-register'
import CompanyParents from './components/company-parents'
import CompanySons from './components/company-sons'
import BusinessLicense from './components/business-license'
import ArticlesAssociation from './components/articles-association'
import AnnualReportInc from './components/annual-report-inc'
import AuthorIdentity from './components/author-identity'
import PersonCertificate from './components/person-certificate'
import ResolutionPower from './components/resolution-power'
// import SourceFunds from './components/source-funds'
// import SourceWhereabouts from './components/source-whereabouts'
import OtherFunds from './components/other-funds'
import DeclarePage from './components/declare-page'
import RiskSupply from './components/risk-supply'
import LangSelector from '@/components/lang-sel'
import CompanyBasic from './components/company-basic'
import TransactionRelated from './components/transaction-related'

import businessTerviceTrade from '@/common/businessTerviceTrade'
import businessTradeInGoods from '@/common/businessTradeInGoods'
export default {
  name: 'MerchantInfo',
  components: {
    'company-register': CompanyRegister,
    'company-parents': CompanyParents,
    'company-sons': CompanySons,
    'business-license': BusinessLicense,
    'articles-association': ArticlesAssociation,
    'annual-report-inc': AnnualReportInc,
    'author-identity': AuthorIdentity,
    'person-certificate': PersonCertificate,
    'resolution-power': ResolutionPower,
    // 'source-funds': SourceFunds,
    // 'source-whereabouts': SourceWhereabouts,
    'other-funds': OtherFunds,
    'declare-page': DeclarePage,
    'risk-supply': RiskSupply,
    'company-basic': CompanyBasic,
    'language-selector': LangSelector,
    'transaction-related': TransactionRelated
  },
  setup() {
    const submitRef = ref(null)
    const router = useRouter()
    const state = reactive({
      themeData: inject('$themeData'),
      merchantNo: '',
      countries: [],
      risked: false,
      refused: false,
      pattern: true,
      language: localStorage.getItem('locale-language') || 'zh',
      openKeys: ['1', '2', '3'],
      selectedKeys: ['1-1'],
      refuseAttrs: [],
      companyNameInfo: {
        icon: null,
        countryCode: 'HK',
        countryCodeDisabled: false,
        countryCodeMessage: '',
        merchantNameEn: '',
        merchantNameEnDisabled: false,
        merchantNameEnMessage: '',
        merchantName: '',
        merchantNameDisabled: false,
        merchantNameMessage: ''
      },
      // 公司基础信息
      companyBasicInfo: {
        icon: null,
        merchantRegistrationType: '个人独资企业',
        merchantRegistrationTypeMessage: '',
        merchantRegistrationTypeDisabled: false,
        registrationAddress: '',
        registrationAddressMessage: '',
        registrationAddressDisabled: false,
        companyAddressType: '0',
        companyAddressTypeMessage: '',
        companyAddressTypeDisabled: false,
        truthSwitch: true,
        truthSwitchMessage: '',
        truthSwitchDisabled: false,
        mailingAddress: '',
        mailingAddressMessage: '',
        mailingAddressDisabled: false,
        proofOfRealBusinessAddress: [],
        proofOfRealBusinessAddressMessage: '',
        proofOfRealBusinessAddressDisabled: false
      },
      parentCompanyInfo: {
        icon: null,
        radioShow: '',
        radioShowDisabled: false,
        radioShowMessage: '',
        ownerShipPath: [], // 股权架构图
        ownerShipPathDisabled: false,
        ownerShipPathMessage: '',
        parentCertificatePath: [], // 注册证书及最新的incumbency
        certificatePathDisabled: false,
        certificatePathMessage: '',
        tradeCountry: [{
          country: '', // 母公司注册国家
          name: '' // 母公司注册名称
        }],
        tradeCountryDisabled: false,
        tradeCountryMessage: ''
      },
      branchOfficeSubsidiary: {
        icon: null,
        branchRadio: '',
        branchRadioDisabled: false,
        branchRadioMessage: '',
        tradeCountry: [{
          country: '', // 子公司注册国家
          name: '' // 子公司注册名称
        }],
        tradeCountryDisabled: false,
        tradeCountryMessage: ''
      },
      businessLicenseInfo: {
        icon: null,
        businessLicensePath: [], // 营业执照
        businessLicensePathDisabled: false,
        businessLicensePathMessage: '',
        businessRegistrationCertificatePath: [], // 商业登记证
        certificatePathDisabled: false,
        certificatePathMessage: '',
        incorporationPath: [], // 公司注册证明书
        incorporationPathDisabled: false,
        incorporationPathMessage: '',
        companyCertificatePath: [], // 公司注册证书（CI）
        companyCertificatePathDisabled: false,
        companyCertificatePathMessage: ''
      },
      articlesAssociation: {
        icon: null,
        mermorandumPath: [], // 公司章程
        mermorandumPathDisabled: false,
        mermorandumPathMessage: ''
      },
      annualReportInc: {
        icon: null,
        nar1Path1: [], // 周年年报
        nar1Path1Disabled: false,
        nar1Path1Message: '',
        nnc1Path: [], // 法团成立表
        nnc1PathDisabled: false,
        nnc1PathMessage: ''
      },
      identityInfo: {
        icon: null,
        customerIdentityDisabled: false,
        customerIdentityMessage: '',
        customerIdentity: ['3']
      },
      certufucate: {
        icon: null,
        certuFucateDisabled: false,
        customer: [{
          collDisable: false,
          certificateType: '',
          country: '',
          authorizerPermanentAddress: '',
          cert1: [],
          cert2: [],
          passport: []
        }],
        customerMessage: '',
        legalPerson: [{
          collDisable: true,
          certificateType: '',
          country: '',
          corporatePermanentAddress: '',
          cert1: [],
          cert2: [],
          passport: [],
          cert3: []
        }],
        legalPersonMessage: '',
        directorPerson: [{
          collDisable: true,
          certificateType: '',
          country: '',
          directorPermanentAddress: '',
          cert1: [],
          cert2: [],
          passport: [],
          cert3: []
        }],
        directorPersonMessage: '',
        shareholder: [{
          collDisable: true,
          certificateType: '',
          country: '',
          ratio: '',
          ultimateBeneficiaryPermanentAddress: '',
          cert1: [],
          cert2: [],
          passport: []
        }],
        shareholderMessage: ''
      },
      resolutionPower: {
        icon: null,
        authorizationPath: [], // 董事会决议/授权书
        authorizationPathDisabled: false,
        authorizationPathMessage: ''
      },
      sourceFundsInfo: {
        icon: null,
        sourceFunds: [], // 运营资金来源
        sourceFundsDisabled: false,
        sourceFundsMessage: ''
      },
      sourceWhereabouts: {
        icon: null,
        paymentPurpose: [], // 预计付款目的
        sourceWhereaboutsDisabled: false,
        sourceWhereaboutsMessage: ''
      },
      otherInfo: {
        icon: null,
        docDisabled: false,
        docMessage: '',
        docPath: [],
        supplyDisabled: false,
        supplyMessage: '',
        supplyText: '',
        faceRecognition: '',
        faceRecognitionResult: null,
        faceRecognitionFileUrl: ''
      },
      declareInfo: {
        icon: null,
        declareRadio: '0',
        declareRadioDisabled: false,
        declareRadioMessage: '',
        tradeCountry: [{
          country: '', // 风险交易国家
          name: '' // 风险国家公司名称
        }],
        tradeCountryDisabled: false,
        tradeCountryMessage: '',
        checkOne: false,
        checkTwo: false
      },
      eddRefuseInfo: {
        icon: null,
        customer: [{
          country: '',
          name: ''
        }],
        customerDisabled: false,
        customerMessage: '',
        supplier: [{
          country: '',
          name: ''
        }],
        supplierDisabled: false,
        supplierMessage: '',
        financialStatementsPath: [],
        statementsPathDisabled: false,
        statementsPathMessage: '',
        questionnairePath: [],
        questionnairePathDisabled: false,
        questionnairePathMessage: ''
      },
      // 交易相关信息
      transactionInfo: {
        icon: null,
        businessBackgroundTradeInGoods: [], // 业务性质货物贸易
        businessBackgroundTradeInGoodsDisabled: false,
        businessBackgroundTradeInGoodsMessage: '',
        businessBackgroundServiceTrade: [], // 业务性质服务贸易
        businessBackgroundServiceTradeDisabled: false,
        businessBackgroundServiceTradeMessage: '',
        serviceProvided: '0', // 提供的产品和服务
        serviceProvidedDisabled: false,
        serviceProvidedMessage: '',
        saleOneYear_v_two: '', // 去年的营业额（USD）
        saleOneYear_v_twoDisabled: false,
        saleOneYear_v_twoMessage: '',
        permonthTransactionAmount_v_two: '', // 预估交易量 (每月)(USD)
        permonthTransactionAmount_v_twoDisabled: false,
        permonthTransactionAmount_v_twoMessage: '',
        currentClientCountryCode: [], // 目前客戶所在国家
        currentClientCountryCodeDisabled: false,
        currentClientCountryCodeMessage: '',
        receiptPaymentParticipantsType: [], // 交易对手方类型
        receiptPaymentParticipantsTypeDisabled: false,
        receiptPaymentParticipantsTypeMessage: '',
        allCountry: [], // 在哪个国家/地区经营（开展）业务？
        allCountryDisabled: false,
        allCountryMessage: '',
        currentSuppliersCountryCode: [], // 目前合作伙伴/供应商所在国家
        currentSuppliersCountryCodeDisabled: false,
        currentSuppliersCountryCodeMessage: '',
        exToCollectionServicesReCountriesCode: [], // 目前和预计需要的收款服务的汇入国家
        exToCollectionServicesReCountriesCodeDisabled: false,
        exToCollectionServicesReCountriesCodeMessage: '',
        exFromCollectionServicesReCountriesCode: [], // 目前和预计需要的付款服务的汇出国家
        exFromCollectionServicesReCountriesCodeDisabled: false,
        exFromCollectionServicesReCountriesCodeMessage: '',
        // distributionChannels: [], // 交易模式
        // distributionChannelsDisabled: false,
        // distributionChannelsMessage: '',
        // enterURLOrAppName: '', // 网址或应用程序名称
        // enterURLOrAppNameDisabled: false,
        // enterURLOrAppNameMessage: '',
        companyWebsite: '', // 公司官网
        companyWebsiteDisabled: false,
        companyWebsiteMessage: '',
        employeeNumber: '', // 员工人数
        employeeNumberDisabled: false,
        employeeNumberMessage: '',
        sourceFunds: [], // 运营资金来源
        sourceFundsDisabled: false,
        sourceFundsMessage: '',
        paymentPurpose: [], // 预计付款目的
        sourceWhereaboutsDisabled: false,
        sourceWhereaboutsMessage: ''
      },
      liveness: true,
      kycId: ''
    })

    watch(
      [
        () => state.companyNameInfo,
        () => state.parentCompanyInfo,
        () => state.branchOfficeSubsidiary,
        () => state.businessLicenseInfo,
        () => state.articlesAssociation.mermorandumPath,
        () => state.annualReportInc.nnc1Path,
        () => state.identityInfo.customerIdentity,
        () => state.certufucate,
        () => state.resolutionPower.authorizationPath,
        () => state.sourceFundsInfo.sourceFunds,
        () => state.sourceWhereabouts.paymentPurpose,
        () => state.declareInfo,
        () => state.otherInfo,
        () => state.eddRefuseInfo,
        () => state.companyBasicInfo,
        () => state.transactionInfo
      ],
      (values) => {
        isFullParams(values)
      },
      { deep: true }
    )

    const handleNext = (key) => {
      state.selectedKeys = [key]
      setTemporaryValue()
    }

    const findAndConcat = (data, targets) => {
      const result = []
      const targetSet = new Set(targets) // 将目标值转为 Set 方便查找

      function search(items) {
        for (const item of items) {
          if (targetSet.has(item.value)) {
            result.push(`${item.label}_${item.value}`)
          }
          if (item.children) {
            search(item.children) // 递归查找子节点
          }
        }
      }

      search(data)
      return result
    }
    // 提交KYC
    const handleFinish = async () => {
      const data = {}
      const { countryCode, merchantNameEn, merchantName } = state.companyNameInfo

      if (countryCode && merchantNameEn && state.pattern) {
        data.countryCode = countryCode
        data.merchantNameEn = merchantNameEn
        data.merchantName = merchantName
      } else {
        // return message.error(i18n.global.t('common_text_047') + i18n.global.t('pages_merchant_004'))
      }
      // 公司基础信息
      {
        const { companyAddressType, registrationAddress, truthSwitch, mailingAddress, proofOfRealBusinessAddress, merchantRegistrationType } = state.companyBasicInfo
        data.companyAddressType = companyAddressType
        data.registrationAddress = registrationAddress
        data.merchantRegistrationType = merchantRegistrationType
        if (truthSwitch) {
          data.mailingAddress = registrationAddress
        } else {
          data.mailingAddress = mailingAddress
          data.proofOfRealBusinessAddress = proofOfRealBusinessAddress
        }
      }

      // {
      //   const { radioShow, tradeCountry, ownerShipPath, parentCertificatePath } = state.parentCompanyInfo
      //   const flash1 = tradeCountry ? tradeCountry.some(item => (!item.country || !item.name)) : ''
      //   const flash2 = tradeCountry ? tradeCountry.some(item => item.country !== 'CN') : ''
      //   if ((ownerShipPath.length !== 0 && ((flash2 && parentCertificatePath.length !== 0) || !flash2) && (radioShow === '1' && !flash1)) || radioShow === '0') {
      //     data.isParentCertificate = radioShow
      //     data.parentCertificatePath = parentCertificatePath
      //     data.ownerShipPath = ownerShipPath
      //     data.parentCertificate = tradeCountry.map(item => {
      //       return {
      //         parentCertificateName: item.name,
      //         parentCertificateCountry: item.country
      //       }
      //     })
      //   } else {
      //     // return message.error(i18n.global.t('common_text_047') + i18n.global.t('pages_merchant_005'))
      //   }
      // }

      // {
      //   const { branchRadio, tradeCountry } = state.branchOfficeSubsidiary
      //   const flash = tradeCountry.some(item => (!item.country || !item.name))
      //   if ((branchRadio === '1' && !flash) || branchRadio === '0') {
      //     data.isResides = branchRadio
      //     data.resides = tradeCountry.map(item => {
      //       return {
      //         residesName: item.name,
      //         residesCountry: item.country
      //       }
      //     })
      //   } else {
      //     // return message.error(i18n.global.t('common_text_047') + i18n.global.t('pages_merchant_006'))
      //   }
      // }

      {
        const { businessLicensePath, businessRegistrationCertificatePath, incorporationPath, companyCertificatePath } = state.businessLicenseInfo
        if (countryCode === 'CN' && businessLicensePath.length !== 0) {
          data.businessLicensePath = businessLicensePath
        } else if (countryCode === 'HK' && businessRegistrationCertificatePath.length !== 0 && companyCertificatePath.length !== 0) {
          data.businessRegistrationCertificatePath = businessRegistrationCertificatePath
          data.companyCertificatePath = companyCertificatePath
        } else if (!['CN', 'HK'].includes(countryCode) && incorporationPath.length !== 0) {
          data.incorporationPath = incorporationPath
        } else {
          // return message.error(`${i18n.global.t('common_text_047')}${countryCode === 'CN' ? i18n.global.t('pages_merchant_007') : countryCode === 'HK' ? i18n.global.t('pages_merchant_016') : i18n.global.t('pages_merchant_017')}`)
        }
      }

      {
        const { mermorandumPath } = state.articlesAssociation
        const { nar1Path1, nnc1Path } = state.annualReportInc
        data.mermorandumPath = mermorandumPath
        data.nar1Path1 = nar1Path1
        data.nar1Path = nar1Path1
        data.nnc1Path = nnc1Path
        // if (!['CN', 'HK'].includes(countryCode)) {
        //   if (mermorandumPath.length === 0) return message.error(i18n.global.t('common_text_047') + i18n.global.t('pages_merchant_018'))
        //   if (nnc1Path.length === 0) return message.error(i18n.global.t('common_text_047') + i18n.global.t('pages_merchant_019'))
        // }
      }

      // {
      //   const { customerIdentity } = state.identityInfo
      //   if (customerIdentity.length !== 0) {
      //     data.customerIdentity = customerIdentity
      //   } else {
      //     // return message.error(i18n.global.t('common_text_047') + i18n.global.t('pages_merchant_008'))
      //   }
      // }

      {
        const { customer, legalPerson, directorPerson, shareholder } = state.certufucate
        const flash1 = customer.some(item => !item.certificateType || !item.authorizerPermanentAddress || (item.certificateType === '0' && (item.cert1.length === 0 || item.cert2.length === 0)) || item.certificateType === '1' && item.passport.length === 0)
        const flash2 = legalPerson.some(item => !item.certificateType || !item.corporatePermanentAddress || (item.certificateType === '0' && (item.cert1.length === 0 || item.cert2.length === 0)) || item.certificateType === '1' && item.passport.length === 0 || item.cert3 && item.cert3.length === 0)
        const flash3 = directorPerson.some(item => !item.certificateType || !item.directorPermanentAddress || (item.certificateType === '0' && (item.cert1.length === 0 || item.cert2.length === 0)) || item.certificateType === '1' && item.passport.length === 0 || item.cert3 && item.cert3.length === 0)
        const flash4 = shareholder.some(item => !item.certificateType || !item.ultimateBeneficiaryPermanentAddress || !item.ratio || (item.certificateType === '0' && (item.cert1.length === 0 || item.cert2.length === 0)) || item.certificateType === '1' && item.passport.length === 0)
        if (!flash1 && (countryCode === 'CN' ? !flash2 : !flash3) && !flash4) {
          data.customer = customer.map(item => {
            // data.authorizerPermanentAddress = item.authorizerPermanentAddress
            return {
              customerType: item.certificateType,
              customerIssuancePlace: item.country,
              authorizerPermanentAddress: item.authorizerPermanentAddress,
              customerIDPath: item.certificateType === '0' ? item.cert1.concat(item.cert2) : item.passport
            }
          })
          if (countryCode === 'CN') {
            data.legalPerson = legalPerson.map(item => {
              // data.corporatePermanentAddress = item.corporatePermanentAddress
              return {
                legalPersonCertificateType: item.certificateType,
                legalPersonCertificateIssuancePlace: item.country,
                corporatePermanentAddress: item.corporatePermanentAddress,
                legalPersonCertificatePath: item.certificateType === '0' ? item.cert1.concat(item.cert2, item.cert3) : item.passport.concat(item.cert3)
              }
            })
            data.director = [{
              directorCertificateType: '',
              directorCertificateIssuancePlace: '',
              directorPermanentAddress: '',
              directorCertificatePath: []
            }]
          } else {
            data.director = directorPerson.map(item => {
              // data.directorPermanentAddress = item.directorPermanentAddress
              return {
                directorCertificateType: item.certificateType,
                directorCertificateIssuancePlace: item.country,
                directorPermanentAddress: item.directorPermanentAddress,
                directorCertificatePath: item.certificateType === '0' ? item.cert1.concat(item.cert2, item.cert3) : item.passport.concat(item.cert3)
              }
            })
            data.legalPerson = [{
              legalPersonCertificateType: '',
              legalPersonCertificateIssuancePlace: '',
              corporatePermanentAddress: '',
              legalPersonCertificatePath: []
            }]
          }
          data.shareholder = shareholder.map(item => {
            // data.ultimateBeneficiaryPermanentAddress = item.ultimateBeneficiaryPermanentAddress
            return {
              shareholderCertificateType: item.certificateType,
              shareholderCertificateIssuancePlace: item.country,
              ultimateBeneficiaryRatio: item.ratio,
              ultimateBeneficiaryPermanentAddress: item.ultimateBeneficiaryPermanentAddress,
              shareholderCertificatePath: item.certificateType === '0' ? item.cert1.concat(item.cert2) : item.passport
            }
          })
        } else {
          // return message.error(i18n.global.t('common_text_047') + i18n.global.t('pages_merchant_009'))
        }
      }

      {
        const { authorizationPath } = state.resolutionPower
        if (authorizationPath.length !== 0) {
          data.authorizationPath = authorizationPath
        } else {
          // return message.error(i18n.global.t('common_text_047') + i18n.global.t('pages_merchant_010'))
        }
      }
      // 运营资金来源
      // {
      //   const { sourceFunds } = state.sourceFundsInfo
      //   if (sourceFunds.length !== 0) {
      //     data.sourceFunds = sourceFunds
      //   } else {
      //     return message.error(i18n.global.t('common_text_047') + i18n.global.t('pages_merchant_011'))
      //   }
      // }
      // 0217取消活体必填
      {
        const { faceRecognitionFileUrl, faceRecognition } = state.otherInfo
        if (!faceRecognitionFileUrl && !faceRecognition && state.liveness) {
          // return message.error(i18n.global.t('common_text_047') + i18n.global.t('pages_merchant_147'))
        }
      }

      // 预期付款目的
      // {
      //   const { paymentPurpose } = state.sourceWhereabouts
      //   if (paymentPurpose.length !== 0) {
      //     data.paymentPurpose = paymentPurpose
      //   } else {
      //     return message.error(i18n.global.t('common_text_047') + i18n.global.t('pages_merchant_012'))
      //   }
      // }
      {
        const { docPath, supplyText, faceRecognition, faceRecognitionResult, faceRecognitionFileUrl } = state.otherInfo
        data.accessories = docPath
        data.approvePurpose = supplyText
        data.faceRecognition = faceRecognition
        data.faceRecognitionResult = faceRecognitionResult
        data.faceRecognitionFileUrl = faceRecognitionFileUrl
      }

      {
        const { declareRadio, tradeCountry } = state.declareInfo
        data.isRiskCountryTransaction = declareRadio
        data.riskTransaction = tradeCountry.map(item => {
          return {
            riskTransactionCompanyName: item.name,
            riskTransactionCountry: item.country
          }
        })
      }
      // 交易相关信息
      {
        const { businessBackgroundTradeInGoods,
          businessBackgroundServiceTrade,
          serviceProvided,
          saleOneYear_v_two,
          permonthTransactionAmount_v_two,
          currentClientCountryCode,
          receiptPaymentParticipantsType,
          allCountry,
          currentSuppliersCountryCode,
          exToCollectionServicesReCountriesCode,
          exFromCollectionServicesReCountriesCode,
          // distributionChannels,
          // enterURLOrAppName,
          companyWebsite,
          employeeNumber,
          sourceFunds,
          paymentPurpose
        } = state.transactionInfo
        if ((businessBackgroundTradeInGoods.length > 0 || businessBackgroundServiceTrade.length > 0) && saleOneYear_v_two !== '' && permonthTransactionAmount_v_two !== '' && currentClientCountryCode.length > 0 && receiptPaymentParticipantsType.length > 0 && allCountry.length > 0 && currentSuppliersCountryCode.length > 0 && exToCollectionServicesReCountriesCode.length > 0 && exFromCollectionServicesReCountriesCode.length > 0 && employeeNumber !== '') {
          data.businessBackgroundTradeInGoods = serviceProvided === '0' ? findAndConcat(businessTradeInGoods, businessBackgroundTradeInGoods) : []
          data.businessBackgroundServiceTrade = serviceProvided === '1' ? findAndConcat(businessTerviceTrade, businessBackgroundServiceTrade) : []
          data.serviceProvided = serviceProvided
          data.saleOneYear_v_two = saleOneYear_v_two
          data.permonthTransactionAmount_v_two = permonthTransactionAmount_v_two
          data.currentClientCountryCode = currentClientCountryCode
          data.receiptPaymentParticipantsType = receiptPaymentParticipantsType
          data.allCountry = allCountry
          data.currentSuppliersCountryCode = currentSuppliersCountryCode
          data.exToCollectionServicesReCountriesCode = exToCollectionServicesReCountriesCode
          data.exFromCollectionServicesReCountriesCode = exFromCollectionServicesReCountriesCode
          // data.distributionChannels = distributionChannels
          // data.enterURLOrAppName = enterURLOrAppName
          data.sourceFunds = sourceFunds
          data.paymentPurpose = paymentPurpose
          data.companyWebsite = companyWebsite
          data.employeeNumber = employeeNumber
        } else {
          // return message.error(i18n.global.t('common_text_047') + i18n.global.t('pages_merchant_161'))
        }
      }
      // {
      //   const { financialStatementsPath, questionnairePath, customer, supplier } = state.eddRefuseInfo
      //   console.log(customer, 'state.eddRefuseInfo++++++++++++++++++')
      //   const flash1 = customer.some(item => (!item.country || !item.name))
      //   const flash2 = supplier.some(item => (!item.country || !item.name))
      //   if (state.risked && (questionnairePath.length === 0 || flash1 || flash2)) {
      //     return message.error(i18n.global.t('common_text_047') + 'EDD')
      //   } else {
      //     data.financialStatementsPath = financialStatementsPath
      //     data.questionnairePath = questionnairePath
      //     data.bestPerformingClient = customer.map(item => {
      //       return {
      //         bestPerformingClientName: item.name,
      //         bestPerformingClientCountry: item.country
      //       }
      //     })
      //     data.bestSupplierPartner = supplier.map(item => {
      //       return {
      //         bestPerformerSupplierPartnerName: item.name,
      //         bestPerformerSupplierPartnerCountry: item.country
      //       }
      //     })
      //   }
      // }
      submitRef.value.loading = true
      const res = await _user.approveMaterial(data)
      submitRef.value.loading = false
      if (res.data.succ) {
        message.success(i18n.global.t('pages_merchant_105'))
        router.replace({ path: 'guide_success', query: { isBack: true }})
      } else if (res.data.resCode === '010039') {
        message.error(i18n.global.t('pages_merchant_106'))
      } else {
        message.error(res.data.resMsg)
      }
    }

    const countryChange = () => {
      state.identityInfo.customerIdentity = ['3']
      identityChange()
    }

    const identityChange = () => {
      if (state.refused) return
      const attrs = ['customer', 'legalPerson', 'directorPerson', 'shareholder']
      for (const attr of attrs) {
        if (attr === 'customer') {
          state.certufucate[attr] = [{
            collDisable: attr !== 'customer',
            certificateType: '',
            country: '',
            authorizerPermanentAddress: '',
            cert1: [],
            cert2: [],
            passport: []
          }]
        } else if (attr === 'shareholder') {
          state.certufucate[attr] = [{
            collDisable: attr !== 'customer',
            certificateType: '',
            country: '',
            ultimateBeneficiaryPermanentAddress: '',
            ratio: '',
            cert1: [],
            cert2: [],
            passport: []
          }]
        } else if (attr === 'legalPerson') {
          state.certufucate[attr] = [{
            collDisable: attr !== 'customer',
            certificateType: '',
            country: '',
            corporatePermanentAddress: '',
            cert1: [],
            cert2: [],
            passport: [],
            cert3: []
          }]
        } else if (attr === 'directorPerson') {
          state.certufucate[attr] = [{
            collDisable: attr !== 'customer',
            certificateType: '',
            country: '',
            directorPermanentAddress: '',
            cert1: [],
            cert2: [],
            passport: [],
            cert3: []
          }]
        }
      }
    }

    const initPage = async () => {
      const res = await _home.getMerchantInfo()
      if (res.data.succ) {
        const { status, merchantNo, liveness, kycId } = res.data.data
        state.merchantNo = merchantNo
        state.liveness = liveness
        state.kycId = kycId
        if (status === 'CUSTREJ') loadMerchantInfo()
        else loadTemporaryValue()
      }
      loadAreaPub()
    }

    const loadMerchantInfo = async () => {
      const res = await _user.getRejectCustomerKyc()
      if (res.data.succ) {
        const { data } = res.data
        state.refused = true
        if (data.levelFlag === '1') state.risked = true
        dealMerchantInfo(data.merchantInfo, data.rejectFileName)
      }
    }

    const loadTemporaryValue = async () => {
      const res = await _user.getTemporaryValue({ key: state.merchantNo })
      if (res.data.succ) {
        const { data } = res.data
        if (data) {
          const info = JSON.parse(data)
          state.selectedKeys = [info.stepName || '1-1']
          state.companyNameInfo = info.companyNameInfo
          state.parentCompanyInfo = info.parentCompanyInfo
          state.branchOfficeSubsidiary = info.branchOfficeSubsidiary
          state.businessLicenseInfo = info.businessLicenseInfo
          state.articlesAssociation = info.articlesAssociation
          state.annualReportInc = info.annualReportInc
          state.certufucate = info.certufucate
          state.resolutionPower = info.resolutionPower
          // state.sourceFundsInfo = info.sourceFundsInfo
          // state.sourceWhereabouts = info.sourceWhereabouts
          state.declareInfo = info.declareInfo
          state.eddRefuseInfo = info.eddRefuseInfo
          if (info.otherInfo) state.otherInfo = info.otherInfo
          state.companyBasicInfo = info.companyBasicInfo
          state.transactionInfo = info.transactionInfo
        }
      }
    }

    const loadAreaPub = async () => {
      const res = await _receive.getAreaPub()
      if (res.data.succ) {
        state.countries = res.data.data
      }
    }

    const setTemporaryValue = () => {
      const data = {
        stepName: state.selectedKeys[0],
        merchantNo: state.merchantNo,
        companyNameInfo: state.companyNameInfo,
        parentCompanyInfo: state.parentCompanyInfo,
        branchOfficeSubsidiary: state.branchOfficeSubsidiary,
        businessLicenseInfo: state.businessLicenseInfo,
        articlesAssociation: state.articlesAssociation,
        annualReportInc: state.annualReportInc,
        resolutionPower: state.resolutionPower,
        identityInfo: state.identityInfo,
        certufucate: state.certufucate,
        // sourceFundsInfo: state.sourceFundsInfo,
        // sourceWhereabouts: state.sourceWhereabouts,
        declareInfo: state.declareInfo,
        eddRefuseInfo: state.eddRefuseInfo,
        otherInfo: state.otherInfo,
        companyBasicInfo: state.companyBasicInfo,
        transactionInfo: state.transactionInfo
      }
      _user.setTemporaryValue({
        key: state.merchantNo,
        value: JSON.stringify(data)
      })
    }
    // 编辑KYC
    const dealMerchantInfo = (merchantInfo, rejectFileName) => {
      const { countryCode, merchantNameEn, isParentCertificate, parentCertificate, ownerShipPath, parentCertificatePath,
        isResides, resides, businessLicensePath, incorporationPath, businessRegistrationCertificatePath, mermorandumPath,
        nar1Path1, nnc1Path, customerIdentity, customer, legalPerson, director, shareholder, authorizationPath,
        isRiskCountryTransaction, riskTransaction, financialStatementsPath, questionnairePath, bestPerforming,
        bestPerformer, accessories, approvePurpose, faceRecognition, faceRecognitionResult, faceRecognitionFileUrl,
        companyCertificatePath,
        // 交易相关信息
        businessBackgroundTradeInGoods,
        businessBackgroundServiceTrade,
        serviceProvided,
        saleOneYear_v_two,
        permonthTransactionAmount_v_two,
        currentClientCountryCode,
        receiptPaymentParticipantsType,
        allCountry,
        currentSuppliersCountryCode,
        exToCollectionServicesReCountriesCode,
        exFromCollectionServicesReCountriesCode,
        // distributionChannels,
        // enterURLOrAppName,
        companyWebsite,
        employeeNumber,
        sourceFunds,
        paymentPurpose,
        // KYC补充信息
        merchantName, registrationAddress, merchantRegistrationType, companyAddressType, mailingAddress, proofOfRealBusinessAddress } = merchantInfo
      const refuseAttrs = Object.keys(rejectFileName)
      state.refuseAttrs = refuseAttrs
      state.companyNameInfo = {
        icon: (refuseAttrs.includes('countryCode') || (refuseAttrs.includes('merchantNameEn') && refuseAttrs.includes('merchantName'))) ? 3 : 2,
        countryCode,
        countryCodeDisabled: !refuseAttrs.includes('countryCode'),
        countryCodeMessage: rejectFileName['countryCode'],
        merchantNameEn,
        merchantNameEnDisabled: !refuseAttrs.includes('merchantNameEn'),
        merchantNameEnMessage: rejectFileName['merchantNameEn'],
        merchantName,
        merchantNameDisabled: !refuseAttrs.includes('merchantName'),
        merchantNameMessage: rejectFileName['merchantName']
      }
      state.companyBasicInfo = {
        icon: (refuseAttrs.includes('mailingAddress') || refuseAttrs.includes('registrationAddress')) ? 3 : 2,
        companyAddressType,
        companyAddressTypeMessage: rejectFileName['companyAddressType'],
        companyAddressTypeDisabled: !refuseAttrs.includes('companyAddressType'),

        registrationAddress,
        registrationAddressMessage: rejectFileName['registrationAddress'],
        registrationAddressDisabled: !refuseAttrs.includes('registrationAddress'),

        merchantRegistrationType,
        merchantRegistrationTypeMessage: rejectFileName['merchantRegistrationType'],
        merchantRegistrationTypeDisabled: !refuseAttrs.includes('merchantRegistrationType'),

        mailingAddress,
        mailingAddressMessage: rejectFileName['mailingAddress'],
        mailingAddressDisabled: !refuseAttrs.includes('mailingAddress'),

        proofOfRealBusinessAddress,
        proofOfRealBusinessAddressMessage: rejectFileName['proofOfRealBusinessAddress'],
        proofOfRealBusinessAddressDisabled: !refuseAttrs.includes('proofOfRealBusinessAddress'),

        truthSwitch: !proofOfRealBusinessAddress
      }
      state.parentCompanyInfo = {
        icon: (refuseAttrs.includes('isParentCertificate') || refuseAttrs.includes('parentCertificate') || refuseAttrs.includes('ownerShipPath') || refuseAttrs.includes('parentCertificatePath')) ? 3 : 2,
        radioShow: isParentCertificate,
        radioShowDisabled: !refuseAttrs.includes('isParentCertificate'),
        radioShowMessage: rejectFileName['isParentCertificate'],
        ownerShipPath,
        ownerShipPathDisabled: !refuseAttrs.includes('ownerShipPath'),
        ownerShipPathMessage: rejectFileName['ownerShipPath'],
        parentCertificatePath: parentCertificatePath,
        certificatePathDisabled: !refuseAttrs.includes('parentCertificatePath'),
        certificatePathMessage: rejectFileName['parentCertificatePath'],
        tradeCountry: parentCertificate,
        tradeCountryDisabled: !refuseAttrs.includes('parentCertificate'),
        tradeCountryMessage: rejectFileName['parentCertificate']
      }
      state.branchOfficeSubsidiary = {
        icon: (refuseAttrs.includes('isResides') || refuseAttrs.includes('resides')) ? 3 : 2,
        branchRadio: isResides,
        branchRadioDisabled: !refuseAttrs.includes('isResides'),
        branchRadioMessage: rejectFileName['isResides'],
        tradeCountry: resides,
        tradeCountryDisabled: !refuseAttrs.includes('resides'),
        tradeCountryMessage: rejectFileName['resides']
      }
      state.businessLicenseInfo = {
        icon: (refuseAttrs.includes('businessLicensePath') || refuseAttrs.includes('incorporationPath') || refuseAttrs.includes('businessRegistrationCertificatePath') || refuseAttrs.includes('companyCertificatePath')) ? 3 : 2,
        businessLicensePath,
        businessLicensePathDisabled: !refuseAttrs.includes('businessLicensePath'),
        businessLicensePathMessage: rejectFileName['businessLicensePath'],
        businessRegistrationCertificatePath,
        certificatePathDisabled: !refuseAttrs.includes('businessRegistrationCertificatePath'),
        certificatePathMessage: rejectFileName['businessRegistrationCertificatePath'],
        incorporationPath,
        incorporationPathDisabled: !refuseAttrs.includes('incorporationPath'),
        incorporationPathMessage: rejectFileName['incorporationPath'],
        companyCertificatePath,
        companyCertificatePathDisabled: !refuseAttrs.includes('companyCertificatePath'),
        companyCertificatePathMessage: rejectFileName['companyCertificatePath']
      }
      state.articlesAssociation = {
        icon: refuseAttrs.includes('mermorandumPath') ? 3 : 2,
        mermorandumPath,
        mermorandumPathDisabled: !refuseAttrs.includes('mermorandumPath'),
        mermorandumPathMessage: rejectFileName['mermorandumPath']
      }
      state.annualReportInc = {
        icon: (refuseAttrs.includes('nar1Path1') || refuseAttrs.includes('nnc1Path')) ? 3 : 2,
        nar1Path1,
        nar1Path1Disabled: !refuseAttrs.includes('nar1Path1'),
        nar1Path1Message: rejectFileName['nar1Path1'],
        nnc1Path,
        nnc1PathDisabled: !refuseAttrs.includes('nnc1Path'),
        nnc1PathMessage: rejectFileName['nnc1Path']
      }
      state.identityInfo = {
        icon: refuseAttrs.includes('customerIdentity') ? 3 : 2,
        customerIdentity,
        customerIdentityDisabled: !refuseAttrs.includes('customerIdentity'),
        customerIdentityMessage: rejectFileName['customerIdentity']
      }
      state.certufucate = {
        icon: (refuseAttrs.includes('customer') || refuseAttrs.includes('legalPerson') || refuseAttrs.includes('director') || refuseAttrs.includes('shareholder')) ? 3 : 2,
        certuFucateDisabled: !(refuseAttrs.includes('customer') || refuseAttrs.includes('legalPerson') || refuseAttrs.includes('director') || refuseAttrs.includes('shareholder')),
        customer: customer.map(item => {
          return {
            certificateType: item.type,
            country: item.issuancePlace,
            authorizerPermanentAddress: item.address,
            cert1: (item.type === '0' && item.path[0]) ? [item.path[0]] : [],
            cert2: (item.type === '0' && item.path[1]) ? [item.path[1]] : [],
            passport: (item.type === '1' && item.path.length !== 0) ? item.path : []
          }
        }),
        customerMessage: rejectFileName['customer'],
        legalPerson: legalPerson.map(item => {
          return {
            certificateType: item.type,
            country: item.issuancePlace,
            corporatePermanentAddress: item.address,
            cert1: (item.type === '0' && item.path[0]) ? [item.path[0]] : [],
            cert2: (item.type === '0' && item.path[1]) ? [item.path[1]] : [],
            passport: (item.type === '1' && item.path[0]) ? [item.path[0]] : [],
            cert3: item.type === '0' ? item.path[2] ? [item.path[2]] : [] : [item.path[1]]
          }
        }),
        legalPersonMessage: rejectFileName['legalPerson'],
        directorPerson: director.map(item => {
          return {
            certificateType: item.type,
            country: item.issuancePlace,
            directorPermanentAddress: item.address,
            cert1: (item.type === '0' && item.path[0]) ? [item.path[0]] : [],
            cert2: (item.type === '0' && item.path[1]) ? [item.path[1]] : [],
            passport: (item.type === '1' && item.path[0]) ? [item.path[0]] : [],
            cert3: item.type === '0' ? item.path[2] ? [item.path[2]] : [] : [item.path[1]]
          }
        }),
        directorPersonMessage: rejectFileName['director'],
        shareholder: shareholder.map(item => {
          return {
            certificateType: item.type,
            country: item.issuancePlace,
            ratio: item.ratio,
            ultimateBeneficiaryPermanentAddress: item.address,
            cert1: (item.type === '0' && item.path[0]) ? [item.path[0]] : [],
            cert2: (item.type === '0' && item.path[1]) ? [item.path[1]] : [],
            passport: (item.type === '1' && item.path.length !== 0) ? item.path : []
          }
        }),
        shareholderMessage: rejectFileName['shareholder']
      }
      state.resolutionPower = {
        icon: refuseAttrs.includes('authorizationPath') ? 3 : 2,
        authorizationPath,
        authorizationPathDisabled: !refuseAttrs.includes('authorizationPath'),
        authorizationPathMessage: rejectFileName['authorizationPath']
      }
      // state.sourceFundsInfo = {
      //   icon: refuseAttrs.includes('sourceFunds') ? 3 : 2,
      //   sourceFunds,
      //   sourceFundsDisabled: !refuseAttrs.includes('sourceFunds'),
      //   sourceFundsMessage: rejectFileName['sourceFunds']
      // }
      // state.sourceWhereabouts = {
      //   icon: refuseAttrs.includes('paymentPurpose') ? 3 : 2,
      //   paymentPurpose,
      //   sourceWhereaboutsDisabled: !refuseAttrs.includes('paymentPurpose'),
      //   sourceWhereaboutsMessage: rejectFileName['paymentPurpose']
      // }
      state.otherInfo = {
        icon: refuseAttrs.includes('faceRecognition') || refuseAttrs.includes('faceRecognitionFileUrl') || refuseAttrs.includes('faceRecognitionResult') ? 3 : 2,
        docDisabled: !refuseAttrs.includes('accessories'),
        docMessage: rejectFileName['accessories'],
        docPath: accessories,
        supplyDisabled: !refuseAttrs.includes('approvePurpose'),
        supplyMessage: rejectFileName['approvePurpose'],
        supplyText: approvePurpose,
        faceRecognition: rejectFileName['faceRecognition'] || rejectFileName['faceRecognitionFileUrl'] || rejectFileName['faceRecognitionResult'] ? '' : faceRecognition,
        faceRecognitionResult: rejectFileName['faceRecognition'] || rejectFileName['faceRecognitionFileUrl'] || rejectFileName['faceRecognitionResult'] ? 'false' : faceRecognitionResult,
        faceRecognitionFileUrl: faceRecognitionFileUrl,
        faceMessage: rejectFileName['faceRecognition'] || rejectFileName['faceRecognitionFileUrl'] || rejectFileName['faceRecognitionResult']
      }
      state.declareInfo = {
        icon: (refuseAttrs.includes('isRiskCountryTransaction') || refuseAttrs.includes('riskTransaction')) ? 3 : 2,
        declareRadio: isRiskCountryTransaction,
        declareRadioDisabled: !refuseAttrs.includes('isRiskCountryTransaction'),
        declareRadioMessage: rejectFileName['isRiskCountryTransaction'],
        tradeCountry: riskTransaction,
        tradeCountryDisabled: !refuseAttrs.includes('riskTransaction'),
        tradeCountryMessage: rejectFileName['riskTransaction'],
        checkOne: false,
        checkTwo: false
      }
      state.eddRefuseInfo = {
        icon: (refuseAttrs.includes('financialStatementsPath') || refuseAttrs.includes('questionnairePath') || refuseAttrs.includes('bestPerforming') || refuseAttrs.includes('bestPerformer')) ? 3 : 2,
        customer: bestPerforming,
        customerDisabled: !refuseAttrs.includes('bestPerforming'),
        customerMessage: rejectFileName['bestPerforming'],
        supplier: bestPerformer,
        supplierDisabled: !refuseAttrs.includes('bestPerformer'),
        supplierMessage: rejectFileName['bestPerformer'],
        financialStatementsPath,
        statementsPathDisabled: !refuseAttrs.includes('financialStatementsPath'),
        statementsPathMessage: rejectFileName['financialStatementsPath'],
        questionnairePath,
        questionnairePathDisabled: !refuseAttrs.includes('questionnairePath'),
        questionnairePathMessage: rejectFileName['questionnairePath']
      }
      const tradeInGoods = businessBackgroundTradeInGoods.map(item => {
        const lastUnderscoreIndex = item.lastIndexOf('_')
        return Number(item.slice(lastUnderscoreIndex + 1))
      })
      const serviceTrade = businessBackgroundServiceTrade.map(item => {
        const lastUnderscoreIndex = item.lastIndexOf('_')
        return Number(item.slice(lastUnderscoreIndex + 1))
      })
      state.transactionInfo = {
        icon: refuseAttrs.includes('businessBackgroundTradeInGoods') || refuseAttrs.includes('businessBackgroundServiceTrade') || refuseAttrs.includes('serviceProvided') || refuseAttrs.includes('saleOneYear_v_two') ||
          refuseAttrs.includes('permonthTransactionAmount_v_two') || refuseAttrs.includes('allCountry') || refuseAttrs.includes('currentSuppliersCountryCode') || refuseAttrs.includes('exToCollectionServicesReCountriesCode') || refuseAttrs.includes('exFromCollectionServicesReCountriesCode') ||
          refuseAttrs.includes('enterURLOrAppName') || refuseAttrs.includes('companyWebsite') || refuseAttrs.includes('employeeNumber') || refuseAttrs.includes('sourceFunds') || refuseAttrs.includes('paymentPurpose') ? 3 : 2,
        businessBackgroundTradeInGoods: tradeInGoods,
        businessBackgroundTradeInGoodsDisabled: !refuseAttrs.includes('businessBackgroundTradeInGoods'),
        businessBackgroundTradeInGoodsMessage: rejectFileName['businessBackgroundTradeInGoods'],
        businessBackgroundServiceTrade: serviceTrade,
        businessBackgroundServiceTradeDisabled: !refuseAttrs.includes('businessBackgroundServiceTrade'),
        businessBackgroundServiceTradeMessage: rejectFileName['businessBackgroundServiceTrade'],
        serviceProvided,
        serviceProvidedDisabled: !refuseAttrs.includes('serviceProvided'),
        serviceProvidedMessage: rejectFileName['serviceProvided'],
        saleOneYear_v_two,
        saleOneYear_v_twoDisabled: !refuseAttrs.includes('saleOneYear_v_two'),
        saleOneYear_v_twoMessage: rejectFileName['saleOneYear_v_two'],
        permonthTransactionAmount_v_two,
        permonthTransactionAmount_v_twoDisabled: !refuseAttrs.includes('permonthTransactionAmount_v_two'),
        permonthTransactionAmount_v_twoMessage: rejectFileName['permonthTransactionAmount_v_two'],
        currentClientCountryCode,
        currentClientCountryCodeDisabled: !refuseAttrs.includes('currentClientCountryCode'),
        currentClientCountryCodeMessage: rejectFileName['currentClientCountryCode'],
        receiptPaymentParticipantsType,
        receiptPaymentParticipantsTypeDisabled: !refuseAttrs.includes('receiptPaymentParticipantsType'),
        receiptPaymentParticipantsTypeMessage: rejectFileName['receiptPaymentParticipantsType'],
        allCountry,
        allCountryDisabled: !refuseAttrs.includes('allCountry'),
        allCountryMessage: rejectFileName['allCountry'],
        currentSuppliersCountryCode,
        currentSuppliersCountryCodeDisabled: !refuseAttrs.includes('currentSuppliersCountryCode'),
        currentSuppliersCountryCodeMessage: rejectFileName['currentSuppliersCountryCode'],
        exToCollectionServicesReCountriesCode,
        exToCollectionServicesReCountriesCodeDisabled: !refuseAttrs.includes('exToCollectionServicesReCountriesCode'),
        exToCollectionServicesReCountriesCodeMessage: rejectFileName['exToCollectionServicesReCountriesCode'],
        exFromCollectionServicesReCountriesCode,
        exFromCollectionServicesReCountriesCodeDisabled: !refuseAttrs.includes('exFromCollectionServicesReCountriesCode'),
        exFromCollectionServicesReCountriesCodeMessage: rejectFileName['exFromCollectionServicesReCountriesCode'],
        // distributionChannels,
        // distributionChannelsDisabled: !refuseAttrs.includes('distributionChannels'),
        // distributionChannelsMessage: rejectFileName['distributionChannels'],
        // enterURLOrAppName,
        // enterURLOrAppNameDisabled: !refuseAttrs.includes('enterURLOrAppName'),
        // enterURLOrAppNameMessage: rejectFileName['enterURLOrAppName'],
        companyWebsite,
        companyWebsiteDisabled: !refuseAttrs.includes('companyWebsite'),
        companyWebsiteMessage: rejectFileName['companyWebsite'],
        employeeNumber,
        employeeNumberDisabled: !refuseAttrs.includes('employeeNumber'),
        employeeNumberMessage: rejectFileName['employeeNumber'],
        sourceFunds,
        sourceFundsDisabled: !refuseAttrs.includes('sourceFunds'),
        sourceFundsMessage: rejectFileName['sourceFunds'],
        paymentPurpose,
        sourceWhereaboutsDisabled: !refuseAttrs.includes('paymentPurpose'),
        sourceWhereaboutsMessage: rejectFileName['paymentPurpose']
      }
    }
    // 更新KYC
    const isFullParams = (values) => {
      if (!state.refused) {
        const { countryCode } = values[0]
        const { radioShow, tradeCountry, ownerShipPath, parentCertificatePath } = values[1]
        const { businessLicensePath, businessRegistrationCertificatePath, incorporationPath, companyCertificatePath } = values[3]
        const { customer, legalPerson, directorPerson, shareholder } = values[7]
        const { faceRecognition } = values[12]
        const { registrationAddress, truthSwitch, mailingAddress, proofOfRealBusinessAddress } = values[14]
        const { businessBackgroundTradeInGoods,
          businessBackgroundServiceTrade,
          saleOneYear_v_two,
          permonthTransactionAmount_v_two,
          currentClientCountryCode,
          receiptPaymentParticipantsType,
          allCountry,
          currentSuppliersCountryCode,
          exToCollectionServicesReCountriesCode,
          exFromCollectionServicesReCountriesCode,
          // distributionChannels,
          employeeNumber } = values[15]

        state.companyNameInfo.icon = values[0].merchantNameEn && values[0].merchantName && state.pattern ? 2 : null

        state.businessLicenseInfo.icon = ((countryCode === 'CN' && businessLicensePath.length !== 0) ||
          (countryCode === 'HK' && businessRegistrationCertificatePath.length !== 0 && companyCertificatePath.length !== 0) ||
          (!['CN', 'HK'].includes(countryCode) && incorporationPath.length !== 0)) ? 2 : null

        state.articlesAssociation.icon = values[4].length !== 0 ? 2 : null

        state.annualReportInc.icon = values[5].length !== 0 ? 2 : null

        state.identityInfo.icon = values[6].length !== 0 ? 2 : null

        state.resolutionPower.icon = values[8].length !== 0 ? 2 : null

        state.sourceFundsInfo.icon = values[9].length !== 0 ? 2 : null

        state.sourceWhereabouts.icon = values[10].length !== 0 ? 2 : null

        state.otherInfo.icon = faceRecognition ? 2 : null

        state.transactionInfo.icon = (businessBackgroundTradeInGoods.length > 0 || businessBackgroundServiceTrade.length > 0) && saleOneYear_v_two !== '' && permonthTransactionAmount_v_two !== '' && currentClientCountryCode.length > 0 && receiptPaymentParticipantsType.length > 0 && allCountry.length > 0 && currentSuppliersCountryCode.length > 0 && exToCollectionServicesReCountriesCode.length > 0 && exFromCollectionServicesReCountriesCode.length > 0 && employeeNumber !== '' ? 2 : null

        state.companyBasicInfo.icon = ((registrationAddress && truthSwitch) || (mailingAddress && registrationAddress && proofOfRealBusinessAddress.length !== 0)) ? 2 : null

        {
          const flash1 = tradeCountry.some(item => (!item.country || !item.name))
          const flash2 = tradeCountry.some(item => item.country !== 'CN')
          state.parentCompanyInfo.icon = ((ownerShipPath.length !== 0 &&
            ((flash2 && parentCertificatePath.length !== 0) || !flash2) &&
            (radioShow === '1' && !flash1)) || radioShow === '0') ? 2 : null
        }

        {
          const flash = values[2].tradeCountry.some(item => (!item.country || !item.name))
          state.branchOfficeSubsidiary.icon = ((values[2].branchRadio === '1' && !flash) || values[2].branchRadio === '0') ? 2 : null
        }
        {
          const flash1 = customer.some(item => !item.certificateType || !item.authorizerPermanentAddress || (item.certificateType === '0' && (item.cert1.length === 0 || item.cert2.length === 0)) || item.certificateType === '1' && item.passport.length === 0)
          const flash2 = legalPerson.some(item => !item.certificateType || !item.corporatePermanentAddress || (item.certificateType === '0' && (item.cert1.length === 0 || item.cert2.length === 0)) || item.certificateType === '1' && item.passport.length === 0 || item.cert3 && item.cert3.length === 0)
          const flash3 = directorPerson.some(item => !item.certificateType || !item.directorPermanentAddress || (item.certificateType === '0' && (item.cert1.length === 0 || item.cert2.length === 0)) || item.certificateType === '1' && item.passport.length === 0 || item.cert3 && item.cert3.length === 0)
          const flash4 = shareholder.some(item => !item.certificateType || !item.ultimateBeneficiaryPermanentAddress || !item.ratio || (item.certificateType === '0' && (item.cert1.length === 0 || item.cert2.length === 0)) || item.certificateType === '1' && item.passport.length === 0)
          state.certufucate.icon = (!flash1 && (countryCode === 'CN' ? !flash2 : !flash3) && !flash4) ? 2 : null
        }
        {
          const { declareRadio, tradeCountry, checkOne, checkTwo } = values[11]
          const flash = tradeCountry.some(item => (!item.country || !item.name))
          state.declareInfo.icon = (declareRadio === '0' || (declareRadio === '1' && !flash)) && checkOne && checkTwo ? 2 : null
        }
        if (!state.risked) return
        {
          const { questionnairePath, customer, supplier } = values[12]
          const flash1 = customer.some(item => (!item.country || !item.name))
          const flash2 = supplier.some(item => (!item.country || !item.name))
          state.eddRefuseInfo.icon = (questionnairePath.length !== 0 && !flash1 && !flash2) ? 2 : null
        }
      }
    }
    initPage()

    return {
      submitRef,
      handleNext,
      handleFinish,
      countryChange,
      identityChange,
      findAndConcat,
      businessTerviceTrade,
      businessTradeInGoods,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less" scoped>
#merchantInfo {
  text-align: left;
  position: relative;

  .header-nav {
    height: 60px;
    padding: 0 24px;
    margin-bottom: 4px;
    position: absolute;
    right: 0;

    img {
      width: 150px;
    }

    .nav-right {
      margin-left: auto;
      cursor: pointer;

      .ic-lanage {
        color: @main-color;
        font-size: 24px;
      }

      .text {
        margin-left: 8px;
        font-size: 16px;
        font-weight: 600;
      }
    }
  }

  .merchant-body {
    display: flex;

    .body-left {
      width: 333px;
      height: 100vh;
      padding-top: 60px;
      position: relative;
      .menu_icon{
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: #BA8438;
        line-height: 24px;
        text-align: center;
        font-size: 16px;
        font-weight: 600;
      }
      .icon-border{
        width: 8px !important;
        height: 8px !important;
        border-radius: 50%;
        background: #BA8438;
        min-width: 8px !important;
      }
      .body_left_logo {
        position: absolute;
        width: 65%;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
      }

      .ic-error {
        color: @error-color;
      }

      .ic-correct {
        color: @success-color;
      }
    }

    .body-left:deep(.ant-menu-inline) {
      background: #fafafa00;
      color: #fff !important;
    }
    .body-left:deep(.ant-menu-title-content) {
      color: #606060 !important;
    }
    .body-left:deep(.ant-menu-submenu-title) {
      .ant-menu-title-content{
        color: #333333 !important;
        font-weight: 500;
        font-size: 16px;
      }
    }
    .body-left:deep(.ant-menu-item-selected) {
      .ant-menu-title-content{
        color: #BA8438 !important;
      }
    }
    .body-left:deep(.ant-menu-light .ant-menu-submenu-title:hover) {
      color: #fff !important;
    }
    .body-left:deep(.ant-menu-light .ant-menu-submenu-active) {
      color: #fff !important;
    }

    .body-left:deep(.ant-menu-submenu-selected) {
      color: #fff !important;
    }
    .body-left:deep(.ant-menu-submenu-arrow) {
      color: #695F4E !important;
    }
    .body-left:deep(.ant-menu-item-selected){
      background: rgba(244, 240, 235, 1) !important;
    }
    .body-left:deep(.ant-menu-inline .ant-menu-item:after){
      border-right: 0px solid var(--ant-primary-color);
    }
    .body-right {
      .scrollbar-none;
      width: calc(100% - 152px);
      height: calc(100vh - 60px);
      padding: 60px 0 24px 128px;
      overflow: scroll;
    }

    .body-right::-webkit-scrollbar {
      display: none;
    }

    .body-right:deep(.error-area) {
      display: flex;
      padding: 12px 24px;
      border-radius: 5px;
      color: @error-color;
      background: #fef0f0;
      margin-top: 10px;
      text-align: left;
      word-break: break-word;

      .ic-error {
        font-size: 28px;
        margin-right: 12px;
      }
    }

    .body-right:deep(.ant-form-item-label) {
      label {
        font-size: 16px;
      }
    }
  }
}
</style>
